<template>
	<div>
		<div class="row pdf-navbar">
			<div class="my-2 col-12 text-center">
				<p style="color: white;">{{page}} / {{numPages}}</p>
				<b-button pill size="sm" variant="outline-light" class="mx-1" @click="previousPage"><</b-button>
				<b-button pill size="sm" variant="outline-light" class="mx-1" @click="nextPage">></b-button>
				<input class="form-group" type="number" @input="selectPage($event)" :placeholder="'Enter page number'">
			</div>
		</div>
		<div>&nbsp;</div>
		<div class="pdfViewer" >
			<div class="text-center" style="text-align: center; padding-bottom: 15px; padding-top: 100px;">
				<pdf
					:src="'data:application/pdf;base64,'+getFAQPDF"
					@num-pages="numPages = $event"
					:page="page"
					style="display: inline-block; width: 50%" 	
				></pdf>
			</div>
		</div>
	</div>
</template>

<script>
import pdf from 'vue-pdf'
import { mapGetters } from 'vuex'

export default {
	name: 'SiteSetupFAQInfoPdf',
	components: {
		pdf
	},
	data() {
		return {
			src: null,
			response: null,
			page: 1,
			numPages: null,
		}
	},
	methods: {
		nextPage() {
			if(this.page < this.numPages) {
				this.page += 1
			}
		},
		previousPage() {
			if(this.page > 1) {
				this.page -= 1
			}
		},
		selectPage(event) {
			let test = parseInt(event.target.value, 10)
			if(test <= this.numPages && test > 0) {
				this.page = test
			} else if(test <= 0) {
				this.page = 1
			} else {
				this.page = this.numPages
			}
			
		}
	},
	created(){
		let data = this.$route.params
		this.$store.dispatch("getFAQData", data)
	},
	computed: {
		...mapGetters(['getFAQPDF'])
	}
}

</script>

<style scoped>

[v-cloak] { 
	display: none !important; 
}

.pdf-navbar {
	position: fixed;
  top: 0;
	left: 0;
	right: 0;
	z-index: 1;
	background-color: #5c5c5c;
	opacity: 0.9;
}
</style>